export enum ProfessionType {
  Doctor = 0,
  Advisor = 1,
  Other = 2,
}
